export default __webpack_public_path__ + "static/media/consistency.a37327d1.svg";